import { render, staticRenderFns } from "./VisualRankItemCard.vue?vue&type=template&id=17540748&scoped=true&"
import script from "./VisualRankItemCard.vue?vue&type=script&lang=js&"
export * from "./VisualRankItemCard.vue?vue&type=script&lang=js&"
import style0 from "./VisualRankItemCard.vue?vue&type=style&index=0&id=17540748&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17540748",
  null
  
)

export default component.exports